import withViewHide from 'components/common/hoc/withViewHide'
import CompareTrayDesktop from './CompareTrayDesktop'

export default withViewHide(({ compareTrayShow }) => !compareTrayShow)(CompareTrayDesktop)
